<template>
  <div class="d-flex flex-row align-center full-width">
    <v-autocomplete
      auto-select-first
      dense
      height="25px"
      class="required"
      required
      @input="updateValue"
      :filter="customFilter"
      :value="value"
      :rules="$validator.rules.required('State/Province')"
      label="State/Province"
      item-text="label"
      item-value="value"
      v-bind="$attrs"
      :items="util.makeStateAndProvinceSelectOptions()">
    </v-autocomplete>
  </div>
</template>

<script>
import selectMixin from '@satellite/components/mixins/selectMixin';
/**
 * State Select
 * @displayName State Select
 */
export default {
  mixins: [selectMixin],
  props: {
    /**
     * @model
     */
    value: {
      type: String,
      required: false
    },
    /**
     * Select placeholder
     */
    placeholder: {
      type: String,
      required: false,
      default: 'State'
    }
  },
  methods: {
    /**
     * Filter select options
     * @public
     * @param item
     * @param queryText
     * @returns {boolean}
     */
    customFilter(item, queryText) {
      if (item.header) {
        return false;
      }

      const textOne = item.label.toLowerCase();
      const textTwo = item.value.toLowerCase();
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1;
    },
    /**
     * V-model
     * @public
     * @param state
     */
    updateValue(state) {
      this.$emit('input', state);
    }
  }
};
</script>
